import { Box, Button, CircularProgress, Stack } from "@mui/material";
import React from "react";
import FettiInput from "../FettiInput";
import UniversitySearch from "./UniversitySearch";
import { Color, FontStyle, Inputs, SurveyButtonStyle } from "../../constants";
import FettiSelect from "../FettiSelect";
import FettiLongInput from "../FettiLongInput";

const styles = {
  label: {
    ...FontStyle.headingBody,
    fontSize: "1rem",
    // textAlign: 'center',
    lineHeight: "1.4",
    width: "100%",
    maxWidth: "500px",
  },
};

// CREATE TABLE survey_schools_list (
//     id INT PRIMARY KEY AUTO_INCREMENT,
//     dt_created DATETIME DEFAULT NOW(),
//     dt_updated TIMESTAMP DEFAULT CURRENT_TIMESTAMP ON UPDATE CURRENT_TIMESTAMP,
//     school_name VARCHAR(127) NOT NULL,
//     degree VARCHAR(63) NOT NULL,
//     major VARCHAR(63) NOT NULL,
//     start_month VARCHAR(31) NOT NULL,
//     start_year VARCHAR(31) NOT NULL,
//     end_month VARCHAR(31) NOT NULL,
//     end_year VARCHAR(31) NOT NULL,
//     grade VARCHAR(31),
//     activities VARCHAR(511),
//     user_id INT NOT NULL,
//     FOREIGN KEY (user_id) REFERENCES user_data(id)
// );

const maxLengths = {
  school_name: 127,
  degree: 63,
  major: 63,
  start_month: 31,
  start_year: 31,
  end_month: 31,
  end_year: 31,
  grade: 31,
  activities: 511,
};
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const SchoolEditor = ({
  data,
  setData,
  uploading,
  handleSave,
  schoolId,
  canCancel,
  handleCancel,
}) => {
  return (
    <Stack direction="column" spacing={1}>
      <Box sx={styles.label}>School</Box>
      <UniversitySearch
        value={data.school_name}
        setValue={(v) => setData({ ...data, school_name: v })}
      />
      <Box sx={styles.label}>Degree</Box>
      <FettiInput
        value={data.degree}
        onChange={(e) => setData({ ...data, degree: e.target.value })}
        placeholder="i.e. Bachelor's Degree"
        maxLength={maxLengths.degree - 10}
      />
      <Box sx={styles.label}>Major</Box>
      <FettiInput
        value={data.major}
        onChange={(e) => setData({ ...data, major: e.target.value })}
        placeholder="i.e. Computer Science"
        maxLength={maxLengths.major - 10}
      />
      <Box sx={styles.label}>Start Date</Box>
      <Stack direction="row" spacing={1}>
        <FettiSelect
          options={["Month", ...months].map((m) => ({ value: m, label: m }))}
          value={data.start_month}
          onChange={(e) => setData({ ...data, start_month: e.target.value })}
          firstIsPlaceholder
        />
        <FettiSelect
          options={["Year", ...Array(50).keys()].map((y, index) => ({
            value: index === 0 ? y : 2024 - y,
            label: index === 0 ? y : 2024 - y,
          }))}
          value={data.start_year}
          onChange={(e) => setData({ ...data, start_year: e.target.value })}
          firstIsPlaceholder
        />
      </Stack>
      <Box sx={styles.label}>End Date</Box>
      <Stack direction="row" spacing={1}>
        <FettiSelect
          options={["Month", ...months].map((m) => ({ value: m, label: m }))}
          value={data.end_month}
          onChange={(e) => setData({ ...data, end_month: e.target.value })}
          firstIsPlaceholder
        />
        <FettiSelect
          options={["Year", ...Array(50).keys()].map((y, index) => ({
            value: index === 0 ? y : 2026 - y,
            label: index === 0 ? y : 2026 - y,
          }))}
          value={data.end_year}
          onChange={(e) => setData({ ...data, end_year: e.target.value })}
          firstIsPlaceholder
        />
      </Stack>
      <Box sx={styles.label}>Grade</Box>
      <FettiInput
        value={data.grade}
        onChange={(e) => setData({ ...data, grade: e.target.value })}
        placeholder="i.e. 3.2"
        maxLength={maxLengths.grade - 10}
      />
      <Box sx={styles.label}>Description</Box>
      <FettiLongInput
        // ref={textAreaRef}
        value={data.activities}
        onChange={(e) => setData({ ...data, activities: e.target.value })}
        placeholder="Add any activities, honors, or awards that you'd like to share."
        maxLength={maxLengths.activities - 10}
        rows={4}
        style={
          {
            // resize: "none",
            // transition: recentExpanded ? "height 0.2s ease-in-out" : "none",
          }
        }
      />
      <Stack direction="row" sx={{ paddingTop: 1 }} spacing={2}>
        <Button
          sx={{
            ...SurveyButtonStyle.defaultStyling,
            ...SurveyButtonStyle.blueFill,
            borderRadius: Inputs.borderRadius,
            width: "100px",
            minWidth: "100px",
            height: "39px",
            // ...((uploading || !data.school_name.length) && {
            //   border: `1px solid ${Color.deepPurple}40`,
            // }),
          }}
          disableRipple
          fullWidth
          onClick={handleSave}
          disabled={uploading || !data.school_name.length}>
          {uploading ? <CircularProgress size="20px" /> : "Save"}
        </Button>

        {!uploading && canCancel && (
          <Button
            sx={{
              ...SurveyButtonStyle.defaultStyling,
              ...SurveyButtonStyle.blueOutline,
              borderRadius: Inputs.borderRadius,
              width: "100px",
              minWidth: "100px",
              height: "39px",
            }}
            disableRipple
            fullWidth
            onClick={handleCancel}
            disabled={uploading}>
            Cancel
          </Button>
        )}
      </Stack>
    </Stack>
  );
};

export default SchoolEditor;
